import React, { useState } from "react";
import "./home.css";
import { Button, ClickAwayListener } from "@material-ui/core";
import firebase, {
  googleAuthProvider,
  facebookAuthProvider,
} from "../firebase";
import {
  FacebookLoginButton,
  GoogleLoginButton,
} from "react-social-login-buttons";
import LoginHandle from "./loginHandle";
import Banner from "./Banner";
import { TiThMenu } from "react-icons/ti";
import { useHistory, useLocation } from "react-router-dom";
// import { db } from "../firebase.js";
import { useDispatch } from 'react-redux';
import { setCompletedPapers, setOccupiedTopics } from "../../features/Questions/questionSlice";
import { setUser } from "../../features/userSlice";

function HomePage() {
  const [loginShow, setloginShow] = useState(false);
  const [authLoading, setauthLoading] = useState("true");
  const [user, setuser] = useState(null);
  const [sideNav, setsideNav] = useState(false);
  const dispatch = useDispatch();

  // console.log(process.env);
  let history = useHistory();
  let location = useLocation();
  const LoginComponent = () => {
    return (
      <div
        className={`dull-area  d-${loginShow ? "block" : "none"} `}
        onClick={() => {
          setloginShow(!loginShow);
        }}
      >
        <div
          className={`login-component position-fixed d-${
            loginShow ? "flex" : "none"
          } flex-column`}
        >
          <div
            className="close"
            onClick={() => {
              setloginShow(!loginShow);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
            </svg>
          </div>
          <h3 className="text-center pt-3">Signin To</h3>
          <h2 className="text-center pb-4" >TestMock</h2>

          <div className="buttons-login">
            <GoogleLoginButton
              onClick={() => LoginHandle(googleAuthProvider)}
            ></GoogleLoginButton>

            <FacebookLoginButton
              onClick={() => LoginHandle(facebookAuthProvider)}
            ></FacebookLoginButton>
          </div>
        </div>
      </div>
    );
  };


// async function setNewPaper() {
//   var q_array = [];
//   let sub;
//   for (let i = 1; i <= 60; ++i) {
//     if (i < 20) sub = "phy";
//     else if (i < 40) sub = "chem";
//     else sub = "math";
//     q_array.push({
//       subject: sub,
//       src: `https://res.cloudinary.com/ambsite/image/upload/v1619614597/jee/all/Paper%200/60_eb4org.jpg`,
//       ans: "a",
//     });
//   }
//   const docRef = db.collection("Papers").doc(btoa("FULL Paper 1"));
//   docRef
//     .set({
//       title: "FULL Paper 1",
//       data: q_array,
//     })
//     .then(() => {
//       // console.log(newsubs);
//       console.log("Document successfully written!");
//     })
//     .catch((error) => {
//       console.error("Error writing document: ", error);
//     });
// }

  const AfterLoginComponent = () => {
    const [avatarClicked, setavatarClicked] = useState(false);
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        setuser(user);
        setauthLoading("gotUser");
        dispatch(setUser({email : user.email,name : user.displayName}));
      // dispatch(setOccupiedTopics(["FULL Paper 1"]));

        // console.log("got user", user.displayName);
      } else {
        // No user is signed in.
        setauthLoading("notGotUser");
        dispatch(setOccupiedTopics(["FULL Paper 1"]));

        // console.log("not got user");
      }
    });
    // console.log(id);
    const signOut = () => {
          history.push("/");
      firebase
        .auth()
        .signOut()
        .then(() => {
          // Sign-out successful.
          setauthLoading("notGotUser");
          setuser(null);
          dispatch(setUser("", ""));
          dispatch(setOccupiedTopics(["FULL Paper 1"]));
          dispatch(setCompletedPapers([]));
          dispatch(setUser({email : "",name : ""}));

          // history.push("/");
        })
        .catch((error) => {
          // An error happened.
          console.log(error);
        });
    };
    return (
      <>
        {authLoading === "true" && (
          <div class="spinner-border text-primary loginbtn" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        )}
        {authLoading === "notGotUser" && (
          <div className="loginbtn">
            {" "}
            <div
              className="login-div"
              onClick={() => {
                setloginShow(!loginShow);
                setsideNav(false);
              }}
            >
              Get Started
            </div>
          </div>
        )}
        {authLoading === "gotUser" && (
          <div
            className="user-details"
            onClick={() => {
              setavatarClicked(!avatarClicked);
            }}
          >
            <img loading="lazy" src={user.photoURL} alt = "user profile" className="avatar"></img>
          </div>
        )}
        {avatarClicked && (
          <ClickAwayListener
            onClickAway={() => {
              setavatarClicked(false);
            }}
          >
            <div className="hiddenDetails d-flex flex-col">
              <img
                loading="lazy"
                src={user.photoURL}
                alt = "user profile"
                className="hidden-avatar"
              />
              <h4 className="text-center">{user.displayName}</h4>
              <p className="text-sm-center">{user.email}</p>
              <Button color="primary" onClick={() => signOut()}>
                {" "}
                SIGNOUT{" "}
              </Button>
            </div>
          </ClickAwayListener>
        )}
      </>
    );
  };
  // console.log((location.pathname.startsWith('/testPage')))

  return (
    !location.pathname.startsWith("/testPage") &&
    !location.pathname.startsWith("/404") && (
      <div
        className={`home ${
          location.pathname.startsWith("/result") && "home-result"
        }`}
      >
        <div className="d-flex justify-content-center">
          <div
            className="sidebarIcon"
            onClick={() => {
              setsideNav(!sideNav);
              // console.log(sideNav);
            }}
          >
            <TiThMenu size="25" />
          </div>
          {sideNav && (
            <>
              <ClickAwayListener
                onClickAway={() => {
                  setsideNav(false);
                }}
              >
                <div className={`Msidebar`}>
                  <div className="mobUserComponent">
                    <AfterLoginComponent />
                  </div>

                  <h3 className="ml-4 mt-4">Testbook</h3>
                  <p
                    className=" Msidebar-elements p-4"
                    onClick={() => {
                      setsideNav(false);
                      history.push("/");
                    }}
                  >
                    What is TestBook
                  </p>
                  <p
                    className=" Msidebar-elements p-4"
                    onClick={() => {
                      setsideNav(false);
                      history.push("/papers");
                    }}
                  >
                    Papers
                  </p>
                  <p
                    className=" Msidebar-elements p-4"
                    onClick={() => {
                      setsideNav(false);
                      history.push("/");
                    }}
                  >
                    Team
                  </p>
                  <p
                    className=" Msidebar-elements p-4"
                    onClick={() => {
                      setsideNav(false);
                      history.push("/contact");
                    }}
                  >
                    Contact
                  </p>
                  {/* <p
                    className=" Msidebar-elements p-4 font-weight-bold "
                    onClick={() => {
                      setsideNav(false);
                      history.push("/");
                    }}
                  >
                    Purchase
                  </p> */}
                </div>
              </ClickAwayListener>
              <div className="dull-area"></div>
            </>
          )}

          <LoginComponent />
          <div id="id01">
            <AfterLoginComponent />
          </div>
          <div className="header">
            <h1>Testbook</h1>
          </div>
          <div className="navBar d-flex">
            <p
              className=" navBar-elements pt-3 mt-4 ml-5"
              onClick={() => {
                history.push("/");
              }}
            >
              What is TestBook
            </p>
            <p
              className=" navBar-elements pt-3 mt-4 ml-5"
              onClick={() => {
                history.push("/papers");
              }}
            >
              Papers
            </p>
            {/* <p className = " Msidebar-elements pt-3 mt-4 ml-5" onClick = {() => {history.push("/result")}}>Result</p> */}
            <p
              className=" navBar-elements pt-3 mt-4 ml-5"
              onClick={() => {
                history.push("/");
              }}
            >
              Team
            </p>
            <p
              className=" navBar-elements pt-3 mt-4 ml-5"
              onClick={() => {
                history.push("/contact");
              }}
            >
              Contact
            </p>
            {/* <p
              className=" navBar-elements pt-3 mt-4 ml-5 font-weight-bold "
              onClick={() => {
                history.push("/");
              }}
            >
              Purchase
            </p> */}
          </div>
        </div>
        {!location.pathname.startsWith("/result") && <Banner setLoginShow = {setloginShow} loginShow =  {loginShow} />}
        {/* <Button onClick = {() => {setNewPaper()}} >SET PAPER</Button> */}
      </div>
    )
  );

}

export default HomePage;
